/**
 * HEAREN V1.1 — THEME MAPPING (UI → Backend)
 * 
 * This file maps the V1.1 UI theme names to existing backend categories.
 * It is the SINGLE source of truth for the Home card list and TherapyPlayer theme selector.
 * 
 * RULES:
 * - Do NOT change backend categories
 * - Do NOT duplicate audio logic
 * - UI label via i18n (labelKey)
 * - backendId is what gets sent to the API / catalogService
 * - If backendId is null → safe empty state (no crash)
 */

export const V11_THEMES = [
  {
    id: 'nature',
    backendId: 'nature',
    labelKey: 'themes.nature',
    fallbackLabel: 'Nature',
    accent: '#34d399',
    bgImage: '/themes/nature-hero.jpg',
    free: true,
  },
  {
    id: 'relaxation',
    backendId: 'relaxation',
    labelKey: 'themes.relaxation',
    fallbackLabel: 'Relaxation',
    accent: '#fb7185',
    bgImage: '/themes/relaxation.webp',
    free: true,
  },
  {
    id: 'sleep',
    backendId: 'sleep',
    labelKey: 'themes.sleep',
    fallbackLabel: 'Sleep',
    accent: '#818cf8',
    bgImage: '/themes/sleep.webp',
    free: false,
  },
  {
    id: 'meditation',
    backendId: 'meditation',
    labelKey: 'themes.meditation',
    fallbackLabel: 'Meditation',
    accent: '#a78bfa',
    bgImage: '/themes/meditation-new.jpg',
    free: false,
  },
  {
    id: 'pulse_flow',
    backendId: 'pulse_flow',
    labelKey: 'themes.pulseFlow',
    fallbackLabel: 'Pulse Flow',
    accent: '#fbbf24',
    bgImage: '/themes/pulse_flow.webp',
    free: false,
  },
  {
    id: 'instrumental',
    backendId: 'classical',
    labelKey: 'themes.instrumental',
    fallbackLabel: 'Instrumental',
    accent: '#38bdf8',
    bgImage: '/themes/instrumental-new.jpg',
    free: false,
  },
  {
    id: 'lofi',
    backendId: 'chill_lofi',
    labelKey: 'themes.lofi',
    fallbackLabel: 'Lofi',
    accent: '#2dd4bf',
    bgImage: '/themes/lofi.webp',
    free: false,
  },
  //{
    //id: 'deep_calm',
    //backendId: 'deep_calm',
    //labelKey: 'themes.deepCalm',
    //fallbackLabel: 'Deep Calm',
    //accent: '#94a3b8',
    //bgImage: '/themes/deep_calm.avif',
    //free: false,
  //},
];

/**
 * Resolve a V1.1 UI theme ID to a backend category ID.
 * Returns null if no mapping exists (e.g. deep_calm).
 */
export const resolveBackendId = (uiThemeId) => {
  const id = String(uiThemeId || '').toLowerCase().trim();

  if (['instrumental', 'instrumentale', 'classique', 'classical'].includes(id)) {
    return 'classical';
  }

  if (['lofi', 'chill', 'chill_lofi'].includes(id)) {
    return 'chill_lofi';
  }

  const theme = V11_THEMES.find(
    t => String(t.id || '').toLowerCase() === id
  );

  return theme?.backendId ?? null;
};

/**
 * Get V1.1 theme by ID
 */
export const getV11Theme = (id) => V11_THEMES.find(t => t.id === id);

/**
 * Get all V1.1 themes
 */
export const getV11Themes = () => [...V11_THEMES];

export default V11_THEMES;
